import { YesObject } from '@yes.technology/react-toolkit'

/**
 * Copies all defined keys from patch into base. Ignores undefined values to keep the result a valid YesObject.
 */
export function mergeYesObjectWithPartial(
  base: YesObject,
  patch: Partial<YesObject>
): YesObject {
  const result: YesObject = { ...base }
  for (const key of Object.keys(patch)) {
    const value = patch[key as keyof Partial<YesObject>]
    if (value !== undefined) {
      Object.assign(result, { [key]: value })
    }
  }
  return result
}
